import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import PopularBlogs from "./components/PopularBlogs";
import "./styles/blogs.css";

class SCLBlogs extends HTMLElement {
  connectedCallback() {
    if (!this._root) {
      this._root = ReactDOM.createRoot(this);

      // ✅ Read categories from CE attribute
      const categories =
        this.getAttribute("categories") || "All";

      console.log("CE categories:", categories);

      this._root.render(
        <React.StrictMode>
          <App categories={categories} />
        </React.StrictMode>
      );
    }
  }

  disconnectedCallback() {
    this._root?.unmount();
  }
}

customElements.define("scl-blogs", SCLBlogs);

/* ========================================
   Popular Blogs Element
======================================== */
class SCLPopularBlogs extends HTMLElement {
  connectedCallback() {
    if (!this._root) {
      this._root = ReactDOM.createRoot(this);

      const tag = this.getAttribute("tag") || "Popular";

      this._root.render(
        <React.StrictMode>
          <PopularBlogs tag={tag} />
        </React.StrictMode>
      );
    }
  }

  disconnectedCallback() {
    this._root?.unmount();
  }
}

if (!customElements.get("scl-popular-blogs")) {
  customElements.define("scl-popular-blogs", SCLPopularBlogs);
}